import axios from '../Backend';

export const getModules = async (queryObj = {}) => {
    try {
        const res = await axios.get('/api/v2/effective-crms/module', {
            params: queryObj, // Pass query parameters here
        });
        return res.data?.data?.data
    } catch (e) {
        console.log(`getModules :: Error=${e.response?.data ? e.response.data.message : e.message}`)
    }
}

export const getUserModules = async () => {
    try {
        const res = await axios.get('/api/v2/effective-crms/module/user-modules');
        return res.data?.data?.data
    } catch (e) {
        console.log(`getModules :: Error=${e.response?.data ? e.response.data.message : e.message}`)
    }
}

export const patchUserModule = async (patchObj) => {
    try {
        const res = await axios.patch('/api/v2/effective-crms/module/user-modules', patchObj);
        return res.data?.data?.data
    } catch (e) {
        console.log(`getModules :: Error=${e.response?.data ? e.response.data.message : e.message}`)
    }
}